import cx from 'classnames';
import React from 'react';
export const SiteFooter = ({ align, children, className, ...rest }) => (React.createElement("footer", { className: cx('tds-site-footer', { 'tds-site-footer--align_start': align === 'start' }, className), ...rest },
    React.createElement("nav", { className: "tds-footer-nav" },
        React.createElement("ul", { className: "tds-list tds-list--horizontal" }, React.Children.map(children, (child) => child ? React.createElement("li", { className: "tds-footer-item" }, child) : null)))));
